import { CustomBookingMethod } from '~api/som';

import { useNavigate } from 'react-router-dom';
import { Fragment } from 'react/jsx-runtime';

import { CellLayout, EmptyState, InteractiveTable, LoadingTableRows, Table } from '@ingrid/luterkort-react';
import { ShippingLogo } from '@ingrid/react-shipping-logo';

import { Ellipsis } from '~src/components/Ellipsis/Ellipsis';
import { useTranslation } from '~src/i18n/use-translation';
import { AppRoute } from '~src/main/routes';

interface Props {
  data: CustomBookingMethod[];
  isLoading: boolean;
  isEmpty: boolean;
}

export function ListTable(props: Props) {
  const { data, isLoading, isEmpty } = props;

  const navigate = useNavigate();
  const { t } = useTranslation();

  function handleClick(method: string) {
    navigate(`${AppRoute.EDIT}?method=${method}`);
  }

  if (isEmpty) {
    return <EmptyState title={t('bookingRules.list.empty')} />;
  }

  return (
    <Fragment>
      <InteractiveTable.Table>
        <thead>
          <Table.Row>
            <Table.HeadCell css={{ width: '40%' }}>{t('common.name')}</Table.HeadCell>
            <Table.HeadCell css={{ width: '30%' }}>{t('common.shippingMethod')}</Table.HeadCell>
            <Table.HeadCell css={{ width: '30%' }}>{t('common.bookingMethod')}</Table.HeadCell>
          </Table.Row>
        </thead>
        <tbody>
          {data.map((cbm, index) => (
            <InteractiveTable.Row key={`rule-${index}`} value={cbm.id!} onClick={() => handleClick(cbm.method!)}>
              <Table.Cell>
                <Ellipsis>{cbm.name}</Ellipsis>
              </Table.Cell>
              <Table.Cell>
                <CellLayout.Row>
                  <ShippingLogo method={cbm.method} width={32} />
                  <CellLayout.Text>{cbm.method}</CellLayout.Text>
                </CellLayout.Row>
              </Table.Cell>
              <Table.Cell>
                {cbm.booking_method ? (
                  <CellLayout.Row>
                    <ShippingLogo method={cbm.booking_method} width={32} />
                    <CellLayout.Text>{cbm.booking_method}</CellLayout.Text>
                  </CellLayout.Row>
                ) : (
                  '-'
                )}
              </Table.Cell>
            </InteractiveTable.Row>
          ))}
          {isLoading && <LoadingTableRows />}
        </tbody>
      </InteractiveTable.Table>
    </Fragment>
  );
}
